import parseISO from 'date-fns/parseISO';
import format from 'date-fns/format';
import isSameDay from 'date-fns/isSameDay';

const START_DATE_SINGLE_DAY_DISPLAY_FORMAT = 'MMMM dd, yyyy | h:mma';
const END_DATE_SINGLE_DAY_DISPLAY_FORMAT = ' - h:mma';

const START_DATE_MULTI_DAY_DISPLAY_FORMAT = 'MMMM dd, yyyy, h:mma';
const END_DATE_MULTI_DAY_DISPLAY_FORMAT = ' - MMMM dd, yyyy, h:mma';

export const formatDateTime = (sessionStart, sessionEnd) => {
    const sessionStartObject = parseISO(sessionStart);
    const sessionEndObject = parseISO(sessionEnd);
    const isSessionStartAndEndSameDay = isSameDay(sessionStartObject, sessionEndObject);

    const sessionStartDateTime = isSessionStartAndEndSameDay
        ? format(sessionStartObject, START_DATE_SINGLE_DAY_DISPLAY_FORMAT)
        : format(sessionStartObject, START_DATE_MULTI_DAY_DISPLAY_FORMAT);

    const sessionEndDateTime = isSessionStartAndEndSameDay
        ? format(sessionEndObject, END_DATE_SINGLE_DAY_DISPLAY_FORMAT)
        : format(sessionEndObject, END_DATE_MULTI_DAY_DISPLAY_FORMAT);

    return `${sessionStartDateTime}${sessionEndDateTime}`;
};

export const getSpeakerFullName = (speaker) => `${speaker.first_name} ${speaker.last_name}`;
